export default "__VITE_ASSET__wYFKGKJR__"